import React, { useCallback, useEffect, useState } from "react";
import { RefreshCw, Radio } from "lucide-react";
import { api, dateCourte } from "./api";
import { BoutonSombre, Badge } from "./ui";

/* Les inscriptions du site arrivent dans la console toutes les minutes. Une copie continue
   d'être écrite dans le classeur Google, comme filet de sécurité. */
export default function ReglagesSynchro() {
  const [d, setD] = useState(null);
  const [enCours, setEnCours] = useState(false);
  const [dernier, setDernier] = useState(null);

  const charger = useCallback(() => {
    api("/synchro-site/etat").then(setD).catch(() => {});
  }, []);
  useEffect(charger, [charger]);

  const relire = async () => {
    setEnCours(true);
    try {
      setDernier(await api("/synchro-site", { method: "POST" }));
      charger();
    } finally {
      setEnCours(false);
    }
  };

  if (!d) return <p className="text-sm text-[var(--muted)]">Chargement…</p>;
  const ajouts = Object.entries(dernier?.ajouts || {});

  return (
    <div className="bg-white rounded-2xl p-5 border" style={{ borderColor: "var(--border)" }} data-testid="synchro-bloc">
      <div className="flex flex-wrap items-center gap-3">
        <Badge ton={d.en_attente ? "ambre" : "vert"}>
          <Radio size={12} /> {d.en_attente ? `${d.en_attente} en attente` : "à jour"}
        </Badge>
        <span className="text-xs text-[var(--muted)]" data-testid="synchro-resume">
          {d.journal} envoi(s) du site suivis · dernière lecture {d.derniere_synchro ? dateCourte(d.derniere_synchro) : "jamais"}
        </span>
        <BoutonSombre onClick={relire} disabled={enCours} testid="synchro-relire">
          <RefreshCw size={14} className={enCours ? "animate-spin" : ""} /> Vérifier maintenant
        </BoutonSombre>
      </div>
      <p className="text-[11px] text-[var(--muted)] mt-2">
        Inutile en principe : la console relit toute seule chaque minute ce que le site lui envoie.
        À utiliser si une famille vient de s'inscrire et que tu veux la voir tout de suite.
      </p>

      {dernier && (
        <p className="text-xs mt-3" data-testid="synchro-dernier"
          style={{ color: ajouts.length ? "#047857" : "var(--muted)" }}>
          {ajouts.length
            ? `Reprises : ${ajouts.map(([k, v]) => `${v} ${k.replace("Inscriptions_", "")}`).join(" · ")}.`
            : "Rien de nouveau : tout ce que le site a écrit est déjà dans la console."}
        </p>
      )}

      <div className="rounded-2xl px-4 py-3 text-xs mt-4" style={{ background: "var(--primary-tint)" }}>
        <strong>Comment ça marche</strong>
        <ul className="mt-2 space-y-1 text-[var(--muted)]">
          <li>· Chaque formulaire du site dépose sa ligne dans un journal interne, et c'est ce journal que la console reprend, sous le même numéro d'inscription — aucun doublon possible.</li>
          <li>· La console lit ce journal toutes les minutes. Le bouton ci-dessus force la lecture tout de suite.</li>
          <li>· Suivis : inscriptions au semestre, cours d'essai, stages, auditions, réservations de spectacle.</li>
          <li>· Les messages du site (contact, SWICA, cours privés) sont lus en direct dans l'onglet Messages, il n'y a rien à synchroniser.</li>
          <li>· La console ne crée que ce qui manque : une correction faite ici n'est jamais écrasée.</li>
          <li>· Les montants sont recalculés par la console, c'est elle la référence.</li>
        </ul>
      </div>
    </div>
  );
}
